export default "/_next/static/images/c9f0ca5c32f64ca5d938164f9221dfe1.jpg";